import { render } from "./AccountPersonal.vue?vue&type=template&id=bd14b896&scoped=true"
import script from "./AccountPersonal.vue?vue&type=script&lang=js"
export * from "./AccountPersonal.vue?vue&type=script&lang=js"

import "./AccountPersonal.vue?vue&type=style&index=0&id=bd14b896&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-bd14b896"

export default script